import React, { useEffect } from 'react';
import { GlobalStyles } from '@spotify-internal/encore-creator-web';
import { Provider } from 'react-redux';
import {
  Logger,
  Breadcrumb,
  logAppMountApdex,
  createErrorBoundary,
  createLoadingBoundary,
} from '@mrkt/features/Platform';
import { appExperience } from '@mrkt/features/experience-definitions';
import { SnackbarState } from '@mrkt/features/snackbar';
import { configureStore } from '../shared/store';
import { ActionPanelState } from '../features/ActionPanel';
import { SidePanelState } from '../features/SidePanel';
import { BannerState } from '../features/Banner';
import { HelpButtonState } from '../features/HelpWidget';
import { AppError } from './AppError';
import { Routes } from './routes';
import { RemoteConfig } from './RemoteConfig';
import { LoadingIndicator } from '../shared/components/LoadingIndicator';

const defaultStore = configureStore();

// prevents rerenders of globalStyles which sometimes flashes things
const globalStyles = <GlobalStyles scaffoldingLegacy />;

const [ErrorBoundary] = createErrorBoundary({
  view: 'app',
  experience: appExperience,
});

const LoadingBoundary = createLoadingBoundary({
  view: 'app',
  experience: appExperience,
  target: 500,
});

export function App({ store = defaultStore }: any) {
  // log successful mounts
  useEffect(() => {
    Logger.logSuccess('app-mount');
    logAppMountApdex();
  }, []);

  return (
    <>
      {globalStyles}
      <Breadcrumb name="app-mount" />
      <ErrorBoundary fallback={<AppError />}>
        <LoadingBoundary fallback={<LoadingIndicator />}>
          <RemoteConfig>
            <Provider store={store}>
              <SidePanelState>
                <ActionPanelState>
                  <BannerState>
                    <SnackbarState>
                      <HelpButtonState>
                        <Routes />
                      </HelpButtonState>
                    </SnackbarState>
                  </BannerState>
                </ActionPanelState>
              </SidePanelState>
            </Provider>
          </RemoteConfig>
        </LoadingBoundary>
      </ErrorBoundary>
    </>
  );
}
